<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// COMPOSABLES
const { isMonoVersion } = useSaleType(() => sale.type);
</script>

<template>
    <template v-if="isMonoVersion">
        <SdpMaybeTrustReportWrapper :sale="sale">
            <SdpSpecs :sale="sale" />
            <SdpDetails :sale="sale" />
            <SdpDocuments :asset="sale.mainAsset" />
        </SdpMaybeTrustReportWrapper>

        <MktgTrustReport />
    </template>

    <SdpMultiGrid v-else :sale="sale" />
</template>
